import { render, staticRenderFns } from "./ChangeRequestControls.vue?vue&type=template&id=019970ef&scoped=true&"
import script from "./ChangeRequestControls.vue?vue&type=script&lang=js&"
export * from "./ChangeRequestControls.vue?vue&type=script&lang=js&"
import style0 from "./ChangeRequestControls.vue?vue&type=style&index=0&id=019970ef&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "019970ef",
  null
  
)

export default component.exports